// 261026~27 주차 QR 판매 — 홈 주차 QR 칸(ParkingQrIntro)과 앱 켤 때 뜨는 할인 창(ParkingSaleSheet)이 같은 값을 쓴다.
// 261026 대표 컨펌 — 정가 18,000원짜리를 14,000원에 판다는 걸 보이게(취소선 정가 + 할인가)
// 261104 유저 시안(행사 팝업) — 할인 금액 칩 '4,000원 할인'도 여기서(가격을 바꾸면 세 값을 같이 바꾼다)
export const PARKING_PRICE = { list: '18,000원', now: '14,000원', off: '4,000원' };

// 할인 창 기록 — '오늘 하루 보지 않기' 누른 날(localStorage) · 이번에 앱을 켠 뒤 이미 띄움(sessionStorage)
export const PARKING_SALE_HIDE_KEY = 'parking_sale_sheet_hide_date';
export const PARKING_SALE_SHOWN_KEY = 'parking_sale_sheet_shown';

// 폰 시계 기준 'YYYY-MM-DD' — '오늘 하루'를 적고 비교할 때 같은 모양으로
export const localDay = (now = new Date()) =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
